import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import MetaTags from "../../../element/MetaTags";
import Menu from "../components/menu";

const bg = require("../../../../images/servicehero.png");

class ApartmentCleaningGoldCoast extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="Apartment Cleaning Gold Coast | Professional Unit Cleaning"
          description="Apartment cleaning Gold Coast for units, high-rises and rentals. Reliable professional cleaners."
          keywords="apartment cleaning gold coast, unit cleaning gold coast, high-rise cleaning gold coast, apartment cleaners gold coast"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">
                  Apartment Cleaning Services Gold Coast
                </h1>
                <div className="breadcrumb-row">
                  {/* Breadcrumbs can be uncommented if needed */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <Menu />
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        <div className="dlab-info ">
                          <h4 className="dlab-title m-t0">
                            Apartment Cleaning Services Gold Coast
                          </h4>
                          <p>
                            Living in an apartment or unit requires efficient
                            cleaning solutions tailored to compact spaces. Our
                            apartment cleaning Gold Coast service is designed to
                            keep high rise units and residential apartments
                            spotless and hygienic.
                          </p>
                        </div>
                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">Services Include</h4>
                          <ul className="list-check primary">
                            <li>Kitchen cleaning</li>
                            <li>Bathroom sanitisation</li>
                            <li>Floor vacuuming and mopping</li>
                            <li>Balcony cleaning</li>
                            <li>Window cleaning</li>
                          </ul>
                        </div>
                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Move In and Move Out Apartment Cleaning
                          </h4>
                          <p>
                            We provide thorough cleaning for tenants relocating
                            within Gold Coast.
                          </p>
                        </div>
                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">
                            Why Choose Professional Apartment Cleaning
                          </h4>
                          <ul className="list-check primary">
                            <li>Time saving</li>
                            <li>Thorough cleaning</li>
                            <li>Suitable for rental inspections</li>
                            <li>Reliable service</li>
                          </ul>
                        </div>
                        <div className="dlab-info m-t30">
                          <h4 className="dlab-title m-t0">Service Areas</h4>
                          <ul className="list-check primary">
                            <li>Gold Coast</li>
                            <li>Southport</li>
                            <li>Surfers Paradise</li>
                            <li>Broadbeach</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default ApartmentCleaningGoldCoast;
